module.exports = __webpack_public_path__ + "img/lv15.26d4353b.png";